export class Person {
    id: number;
    firstName: string;
    lastName: string;
    company: string;
    title: string;
    email: string
    phoneNumber: string;
}
